<div class="animated fadeIn">
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header">
          <i class="fa fa-code-fork"></i> Versions
        </div>
        <div class="card-body">
          <div class="mb-3">
            <button class="btn btn-sm btn-primary" type="button" (click)="onClickAdd()">
              <i class="fa fa-plus"></i> Add Version
            </button>
          </div>
          <table class="table table-responsive-sm table-hover table-outline mb-0">
            <thead class="thead-light">
              <tr>
                <th>#</th>
                <th>API Version</th>
                <th>Min App Version</th>
                <th>Game Server Version</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @for (version of versions; track version.versionId; let i = $index) {
                <tr>
                  <td>{{ i + 1 }}</td>
                  <td>{{ version.apiVersion }}</td>
                  <td>{{ version.minAppVersion }}</td>
                  <td>{{ version.gameServerVersion }}</td>
                  <td>
                    @if (version.isActive) {
                      <span class="badge bg-success">Active</span>
                    } @else {
                      <span class="badge bg-secondary">Inactive</span>
                    }
                  </td>
                  <td>
                    <button class="btn btn-sm btn-primary me-1" type="button" (click)="onClickEdit(version)" tooltip="Edit" placement="top"><i class="fa fa-edit"></i></button>
                    <span class="text-muted mx-1">|</span>
                    <button class="btn btn-sm btn-danger" type="button" (click)="onClickDelete(version)" tooltip="Delete" placement="top"><i class="fa fa-trash"></i></button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<app-version-add-modal #addModal></app-version-add-modal>
<app-version-edit-modal #editModal></app-version-edit-modal>
